import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'stroke-straight', 'StrokeStraight', [["path",{"d":"M4 19l16 -14"}]]);